// GENERATED by `python scripts/engine.py sync-engine-town` from docs/engine-town (build.py, comic.py, desks.py) and
// the module registries. Do not edit by hand: change those, run the command and commit the result. CI checks they agree.
import type { EngineTownData } from "./engineTown";

export const ENGINE_TOWN: EngineTownData = {
 "width": 1518,
 "height": 964,
 "looks": [
  "office",
  "trade",
  "future"
 ],
 "order": [
  "attract",
  "find",
  "network",
  "connect",
  "reconnect",
  "crm"
 ],
 "buildings": [
  {
   "id": "hq",
   "name": "Settings",
   "kind": "hq",
   "x": 759,
   "y": 107,
   "plate": {
    "x": 759,
    "y": 31
   },
   "hit": {
    "left": 29,
    "top": 23,
    "width": 1460,
    "height": 150
   }
  },
  {
   "id": "attract",
   "name": "Ogma Attract",
   "kind": "module",
   "x": 219,
   "y": 260,
   "plate": {
    "x": 219,
    "y": 199
   },
   "hit": {
    "left": 93,
    "top": 174,
    "width": 251,
    "height": 171
   }
  },
  {
   "id": "find",
   "name": "Ogma Find",
   "kind": "module",
   "x": 219,
   "y": 464,
   "plate": {
    "x": 219,
    "y": 404
   },
   "hit": {
    "left": 93,
    "top": 393,
    "width": 251,
    "height": 142
   }
  },
  {
   "id": "network",
   "name": "Ogma Network",
   "kind": "module",
   "x": 219,
   "y": 643,
   "plate": {
    "x": 219,
    "y": 585
   },
   "hit": {
    "left": 93,
    "top": 561,
    "width": 251,
    "height": 164
   }
  },
  {
   "id": "connect",
   "name": "Ogma Connect",
   "kind": "module",
   "x": 723,
   "y": 408,
   "plate": {
    "x": 723,
    "y": 343
   },
   "hit": {
    "left": 546,
    "top": 280,
    "width": 353,
    "height": 254
   }
  },
  {
   "id": "reconnect",
   "name": "Ogma ReConnect",
   "kind": "module",
   "x": 1110,
   "y": 640,
   "plate": {
    "x": 1110,
    "y": 577
   },
   "hit": {
    "left": 1006,
    "top": 555,
    "width": 207,
    "height": 169
   }
  },
  {
   "id": "complete",
   "name": "Ogma Complete",
   "kind": "soon",
   "x": 1372,
   "y": 453,
   "plate": {
    "x": 1372,
    "y": 396
   },
   "hit": {
    "left": 1283,
    "top": 371,
    "width": 178,
    "height": 164
   }
  },
  {
   "id": "serve",
   "name": "Ogma Serve",
   "kind": "soon",
   "x": 1372,
   "y": 647,
   "plate": {
    "x": 1372,
    "y": 593
   },
   "hit": {
    "left": 1291,
    "top": 568,
    "width": 164,
    "height": 156
   }
  },
  {
   "id": "crm",
   "name": "The CRM",
   "kind": "crm",
   "x": 759,
   "y": 879,
   "plate": {
    "x": 759,
    "y": 797
   },
   "hit": {
    "left": 29,
    "top": 791,
    "width": 1460,
    "height": 155
   }
  }
 ],
 "corridors": {
  "attract": {
   "width": 858,
   "height": 584,
   "offices": [
    {
     "id": "attract:accounts",
     "category": "accounts",
     "title": "Accounts",
     "what": "The accounts this part works through. Connect each once, and Ogma uses it from then on.",
     "desks": 9,
     "hit": {
      "left": 62,
      "top": 12,
      "width": 241,
      "height": 223,
      "clip": "111px 0px, 241px 75px, 130px 223px, 0px 148px"
     },
     "plate": {
      "x": 238,
      "y": 26
     }
    },
    {
     "id": "attract:rules",
     "category": "rules",
     "title": "Rules",
     "what": "How this part behaves: who it is for, how much it does, and what waits for your yes.",
     "desks": 7,
     "hit": {
      "left": 192,
      "top": 87,
      "width": 241,
      "height": 223,
      "clip": "111px 0px, 241px 75px, 130px 223px, 0px 148px"
     },
     "plate": {
      "x": 368,
      "y": 100
     }
    },
    {
     "id": "attract:research",
     "category": "research",
     "title": "Research",
     "what": "What Ogma looks into before it acts, kept up to date for you.",
     "desks": 4,
     "hit": {
      "left": 322,
      "top": 162,
      "width": 241,
      "height": 223,
      "clip": "111px 0px, 241px 75px, 130px 223px, 0px 148px"
     },
     "plate": {
      "x": 498,
      "y": 176
     }
    },
    {
     "id": "attract:actions",
     "category": "actions",
     "title": "Actions",
     "what": "The work itself: drafted, approved where you asked to see it, and sent. Anything that needs you waits here.",
     "desks": 8,
     "hit": {
      "left": 452,
      "top": 237,
      "width": 241,
      "height": 223,
      "clip": "111px 0px, 241px 75px, 130px 223px, 0px 148px"
     },
     "plate": {
      "x": 627,
      "y": 250
     }
    },
    {
     "id": "attract:performance",
     "category": "performance",
     "title": "Performance",
     "what": "How it is going: the results, and the health of every part.",
     "desks": 3,
     "hit": {
      "left": 582,
      "top": 312,
      "width": 241,
      "height": 223,
      "clip": "111px 0px, 241px 75px, 130px 223px, 0px 148px"
     },
     "plate": {
      "x": 757,
      "y": 326
     }
    }
   ],
   "back": {
    "x": 36,
    "y": 171
   },
   "next": {
    "x": 691,
    "y": 549
   }
  },
  "find": {
   "width": 858,
   "height": 584,
   "offices": [
    {
     "id": "find:accounts",
     "category": "accounts",
     "title": "Accounts",
     "what": "The accounts this part works through. Connect each once, and Ogma uses it from then on.",
     "desks": 8,
     "hit": {
      "left": 62,
      "top": 12,
      "width": 241,
      "height": 223,
      "clip": "111px 0px, 241px 75px, 130px 223px, 0px 148px"
     },
     "plate": {
      "x": 238,
      "y": 26
     }
    },
    {
     "id": "find:rules",
     "category": "rules",
     "title": "Rules",
     "what": "How this part behaves: who it is for, how much it does, and what waits for your yes.",
     "desks": 4,
     "hit": {
      "left": 192,
      "top": 87,
      "width": 241,
      "height": 223,
      "clip": "111px 0px, 241px 75px, 130px 223px, 0px 148px"
     },
     "plate": {
      "x": 368,
      "y": 100
     }
    },
    {
     "id": "find:research",
     "category": "research",
     "title": "Research",
     "what": "What Ogma looks into before it acts, kept up to date for you.",
     "desks": 4,
     "hit": {
      "left": 322,
      "top": 162,
      "width": 241,
      "height": 223,
      "clip": "111px 0px, 241px 75px, 130px 223px, 0px 148px"
     },
     "plate": {
      "x": 498,
      "y": 176
     }
    },
    {
     "id": "find:actions",
     "category": "actions",
     "title": "Actions",
     "what": "The work itself: drafted, approved where you asked to see it, and sent. Anything that needs you waits here.",
     "desks": 6,
     "hit": {
      "left": 452,
      "top": 237,
      "width": 241,
      "height": 223,
      "clip": "111px 0px, 241px 75px, 130px 223px, 0px 148px"
     },
     "plate": {
      "x": 627,
      "y": 250
     }
    },
    {
     "id": "find:performance",
     "category": "performance",
     "title": "Performance",
     "what": "How it is going: the results, and the health of every part.",
     "desks": 4,
     "hit": {
      "left": 582,
      "top": 312,
      "width": 241,
      "height": 223,
      "clip": "111px 0px, 241px 75px, 130px 223px, 0px 148px"
     },
     "plate": {
      "x": 757,
      "y": 326
     }
    }
   ],
   "back": {
    "x": 36,
    "y": 171
   },
   "next": {
    "x": 691,
    "y": 549
   }
  },
  "network": {
   "width": 858,
   "height": 584,
   "offices": [
    {
     "id": "network:accounts",
     "category": "accounts",
     "title": "Accounts",
     "what": "The accounts this part works through. Connect each once, and Ogma uses it from then on.",
     "desks": 4,
     "hit": {
      "left": 62,
      "top": 12,
      "width": 241,
      "height": 223,
      "clip": "111px 0px, 241px 75px, 130px 223px, 0px 148px"
     },
     "plate": {
      "x": 238,
      "y": 26
     }
    },
    {
     "id": "network:rules",
     "category": "rules",
     "title": "Rules",
     "what": "How this part behaves: who it is for, how much it does, and what waits for your yes.",
     "desks": 4,
     "hit": {
      "left": 192,
      "top": 87,
      "width": 241,
      "height": 223,
      "clip": "111px 0px, 241px 75px, 130px 223px, 0px 148px"
     },
     "plate": {
      "x": 368,
      "y": 100
     }
    },
    {
     "id": "network:research",
     "category": "research",
     "title": "Research",
     "what": "What Ogma looks into before it acts, kept up to date for you.",
     "desks": 3,
     "hit": {
      "left": 322,
      "top": 162,
      "width": 241,
      "height": 223,
      "clip": "111px 0px, 241px 75px, 130px 223px, 0px 148px"
     },
     "plate": {
      "x": 498,
      "y": 176
     }
    },
    {
     "id": "network:actions",
     "category": "actions",
     "title": "Actions",
     "what": "The work itself: drafted, approved where you asked to see it, and sent. Anything that needs you waits here.",
     "desks": 5,
     "hit": {
      "left": 452,
      "top": 237,
      "width": 241,
      "height": 223,
      "clip": "111px 0px, 241px 75px, 130px 223px, 0px 148px"
     },
     "plate": {
      "x": 627,
      "y": 250
     }
    },
    {
     "id": "network:performance",
     "category": "performance",
     "title": "Performance",
     "what": "How it is going: the results, and the health of every part.",
     "desks": 4,
     "hit": {
      "left": 582,
      "top": 312,
      "width": 241,
      "height": 223,
      "clip": "111px 0px, 241px 75px, 130px 223px, 0px 148px"
     },
     "plate": {
      "x": 757,
      "y": 326
     }
    }
   ],
   "back": {
    "x": 36,
    "y": 171
   },
   "next": {
    "x": 691,
    "y": 549
   }
  },
  "connect": {
   "width": 858,
   "height": 584,
   "offices": [
    {
     "id": "connect:accounts",
     "category": "accounts",
     "title": "Accounts",
     "what": "The accounts this part works through. Connect each once, and Ogma uses it from then on.",
     "desks": 9,
     "hit": {
      "left": 62,
      "top": 12,
      "width": 241,
      "height": 223,
      "clip": "111px 0px, 241px 75px, 130px 223px, 0px 148px"
     },
     "plate": {
      "x": 238,
      "y": 26
     }
    },
    {
     "id": "connect:rules",
     "category": "rules",
     "title": "Rules",
     "what": "How this part behaves: who it is for, how much it does, and what waits for your yes.",
     "desks": 8,
     "hit": {
      "left": 192,
      "top": 87,
      "width": 241,
      "height": 223,
      "clip": "111px 0px, 241px 75px, 130px 223px, 0px 148px"
     },
     "plate": {
      "x": 368,
      "y": 100
     }
    },
    {
     "id": "connect:research",
     "category": "research",
     "title": "Research",
     "what": "What Ogma looks into before it acts, kept up to date for you.",
     "desks": 2,
     "hit": {
      "left": 322,
      "top": 162,
      "width": 241,
      "height": 223,
      "clip": "111px 0px, 241px 75px, 130px 223px, 0px 148px"
     },
     "plate": {
      "x": 498,
      "y": 176
     }
    },
    {
     "id": "connect:actions",
     "category": "actions",
     "title": "Actions",
     "what": "The work itself: drafted, approved where you asked to see it, and sent. Anything that needs you waits here.",
     "desks": 4,
     "hit": {
      "left": 452,
      "top": 237,
      "width": 241,
      "height": 223,
      "clip": "111px 0px, 241px 75px, 130px 223px, 0px 148px"
     },
     "plate": {
      "x": 627,
      "y": 250
     }
    },
    {
     "id": "connect:performance",
     "category": "performance",
     "title": "Performance",
     "what": "How it is going: the results, and the health of every part.",
     "desks": 6,
     "hit": {
      "left": 582,
      "top": 312,
      "width": 241,
      "height": 223,
      "clip": "111px 0px, 241px 75px, 130px 223px, 0px 148px"
     },
     "plate": {
      "x": 757,
      "y": 326
     }
    }
   ],
   "back": {
    "x": 36,
    "y": 171
   },
   "next": {
    "x": 691,
    "y": 549
   }
  },
  "reconnect": {
   "width": 858,
   "height": 584,
   "offices": [
    {
     "id": "reconnect:accounts",
     "category": "accounts",
     "title": "Accounts",
     "what": "The accounts this part works through. Connect each once, and Ogma uses it from then on.",
     "desks": 2,
     "hit": {
      "left": 62,
      "top": 12,
      "width": 241,
      "height": 223,
      "clip": "111px 0px, 241px 75px, 130px 223px, 0px 148px"
     },
     "plate": {
      "x": 238,
      "y": 26
     }
    },
    {
     "id": "reconnect:rules",
     "category": "rules",
     "title": "Rules",
     "what": "How this part behaves: who it is for, how much it does, and what waits for your yes.",
     "desks": 5,
     "hit": {
      "left": 192,
      "top": 87,
      "width": 241,
      "height": 223,
      "clip": "111px 0px, 241px 75px, 130px 223px, 0px 148px"
     },
     "plate": {
      "x": 368,
      "y": 100
     }
    },
    {
     "id": "reconnect:research",
     "category": "research",
     "title": "Research",
     "what": "What Ogma looks into before it acts, kept up to date for you.",
     "desks": 4,
     "hit": {
      "left": 322,
      "top": 162,
      "width": 241,
      "height": 223,
      "clip": "111px 0px, 241px 75px, 130px 223px, 0px 148px"
     },
     "plate": {
      "x": 498,
      "y": 176
     }
    },
    {
     "id": "reconnect:actions",
     "category": "actions",
     "title": "Actions",
     "what": "The work itself: drafted, approved where you asked to see it, and sent. Anything that needs you waits here.",
     "desks": 5,
     "hit": {
      "left": 452,
      "top": 237,
      "width": 241,
      "height": 223,
      "clip": "111px 0px, 241px 75px, 130px 223px, 0px 148px"
     },
     "plate": {
      "x": 627,
      "y": 250
     }
    },
    {
     "id": "reconnect:performance",
     "category": "performance",
     "title": "Performance",
     "what": "How it is going: the results, and the health of every part.",
     "desks": 2,
     "hit": {
      "left": 582,
      "top": 312,
      "width": 241,
      "height": 223,
      "clip": "111px 0px, 241px 75px, 130px 223px, 0px 148px"
     },
     "plate": {
      "x": 757,
      "y": 326
     }
    }
   ],
   "back": {
    "x": 36,
    "y": 171
   },
   "next": {
    "x": 691,
    "y": 549
   }
  },
  "crm": {
   "width": 0,
   "height": 0,
   "back": {
    "x": 0,
    "y": 0
   },
   "next": {
    "x": 0,
    "y": 0
   },
   "offices": [
    {
     "id": "crm:records",
     "category": "records",
     "title": "The records hall",
     "what": "Every person, firm and deal that any building touches is filed here, once, with its whole history.",
     "desks": 6,
     "hit": {
      "left": 0,
      "top": 0,
      "width": 0,
      "height": 0,
      "clip": ""
     },
     "plate": {
      "x": 0,
      "y": 0
     }
    }
   ]
  }
 },
 "rooms": {
  "attract:accounts": {
   "width": 786,
   "height": 599,
   "desks": [
    {
     "id": "desk-0",
     "slug": "website",
     "label": "Website",
     "step": "0.9",
     "to": "/attract/accounts/website",
     "kind": "web",
     "soon": false,
     "hit": {
      "left": 264,
      "top": 142,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 376,
      "y": 165
     }
    },
    {
     "id": "desk-1",
     "slug": "blog",
     "label": "Blog",
     "step": "1.7",
     "to": "/attract/accounts/blog",
     "kind": "type",
     "soon": false,
     "hit": {
      "left": 371,
      "top": 204,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 484,
      "y": 227
     }
    },
    {
     "id": "desk-2",
     "slug": "linkedin",
     "label": "LinkedIn",
     "step": "1.20",
     "to": "/attract/accounts/linkedin",
     "kind": "social",
     "soon": false,
     "hit": {
      "left": 479,
      "top": 266,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 591,
      "y": 289
     }
    },
    {
     "id": "desk-3",
     "slug": "meta",
     "label": "Instagram and Facebook",
     "step": "0.12",
     "to": "/attract/accounts/meta",
     "kind": "social",
     "soon": false,
     "hit": {
      "left": 167,
      "top": 198,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 279,
      "y": 221
     }
    },
    {
     "id": "desk-4",
     "slug": "video",
     "label": "YouTube and TikTok",
     "step": "1.39",
     "to": "/attract/accounts/video",
     "kind": "video",
     "soon": false,
     "hit": {
      "left": 274,
      "top": 260,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 387,
      "y": 283
     }
    },
    {
     "id": "desk-5",
     "slug": "newsletter",
     "label": "Newsletter",
     "step": "0.11",
     "to": "/attract/accounts/newsletter",
     "kind": "type",
     "soon": false,
     "hit": {
      "left": 382,
      "top": 322,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 494,
      "y": 345
     }
    },
    {
     "id": "desk-6",
     "slug": "ads",
     "label": "Ad accounts",
     "step": "0.17",
     "to": "/attract/accounts/ads",
     "kind": "billboard",
     "soon": false,
     "hit": {
      "left": 70,
      "top": 254,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 182,
      "y": 277
     }
    },
    {
     "id": "desk-7",
     "slug": "listings",
     "label": "Listings",
     "step": "0.23",
     "to": "/attract/accounts/listings",
     "kind": "stars",
     "soon": false,
     "hit": {
      "left": 177,
      "top": 316,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 290,
      "y": 339
     }
    },
    {
     "id": "desk-8",
     "slug": "brand",
     "label": "Brand and identity",
     "step": "0.13",
     "to": "/attract/accounts/brand",
     "kind": "palette",
     "soon": false,
     "hit": {
      "left": 285,
      "top": 378,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 397,
      "y": 401
     }
    }
   ],
   "back": {
    "x": 206,
    "y": 242
   }
  },
  "attract:rules": {
   "width": 786,
   "height": 599,
   "desks": [
    {
     "id": "desk-0",
     "slug": "audiences",
     "label": "Audiences, routes and offers",
     "step": "1.19",
     "to": "/attract/rules/audiences",
     "kind": "target",
     "soon": false,
     "hit": {
      "left": 264,
      "top": 142,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 376,
      "y": 165
     }
    },
    {
     "id": "desk-1",
     "slug": "volume",
     "label": "Volume and mix",
     "step": "1.20",
     "to": "/attract/rules/volume",
     "kind": "dial",
     "soon": false,
     "hit": {
      "left": 371,
      "top": 204,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 484,
      "y": 227
     }
    },
    {
     "id": "desk-2",
     "slug": "topics",
     "label": "Topics and news searches",
     "step": "1.2",
     "to": "/attract/rules/topics",
     "kind": "type",
     "soon": false,
     "hit": {
      "left": 479,
      "top": 266,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 591,
      "y": 289
     }
    },
    {
     "id": "desk-3",
     "slug": "ctas",
     "label": "Calls to action",
     "step": "1.49",
     "to": "/attract/rules/ctas",
     "kind": "billboard",
     "soon": false,
     "hit": {
      "left": 167,
      "top": 198,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 279,
      "y": 221
     }
    },
    {
     "id": "desk-4",
     "slug": "ads",
     "label": "Ads",
     "step": "1.26",
     "to": "/attract/rules/ads",
     "kind": "billboard",
     "soon": false,
     "hit": {
      "left": 274,
      "top": 260,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 387,
      "y": 283
     }
    },
    {
     "id": "desk-5",
     "slug": "video-consent",
     "label": "Video consent",
     "step": "1.40",
     "to": "/attract/rules/video-consent",
     "kind": "video",
     "soon": false,
     "hit": {
      "left": 382,
      "top": 322,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 494,
      "y": 345
     }
    },
    {
     "id": "desk-6",
     "slug": "approvals",
     "label": "Approvals",
     "step": "E13",
     "to": "/attract/rules/approvals",
     "kind": "stamp",
     "soon": false,
     "hit": {
      "left": 70,
      "top": 254,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 182,
      "y": 277
     }
    }
   ],
   "back": {
    "x": 206,
    "y": 242
   }
  },
  "attract:research": {
   "width": 581,
   "height": 481,
   "desks": [
    {
     "id": "desk-0",
     "slug": "news",
     "label": "News and topics",
     "step": "1.1",
     "to": "/attract/research/news",
     "kind": "type",
     "soon": true,
     "hit": {
      "left": 167,
      "top": 142,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 279,
      "y": 165
     }
    },
    {
     "id": "desk-1",
     "slug": "past-performance",
     "label": "Past performance",
     "step": "1.55",
     "to": "/attract/research/past-performance",
     "kind": "chart",
     "soon": false,
     "hit": {
      "left": 274,
      "top": 204,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 387,
      "y": 227
     }
    },
    {
     "id": "desk-2",
     "slug": "web-presence",
     "label": "Web presence",
     "step": "0.14",
     "to": "/attract/research/web-presence",
     "kind": "web",
     "soon": false,
     "hit": {
      "left": 70,
      "top": 198,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 182,
      "y": 221
     }
    },
    {
     "id": "desk-3",
     "slug": "keywords",
     "label": "Keywords",
     "step": "1.34",
     "to": "/attract/research/keywords",
     "kind": "search",
     "soon": false,
     "hit": {
      "left": 177,
      "top": 260,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 290,
      "y": 283
     }
    }
   ],
   "back": {
    "x": 157,
    "y": 214
   }
  },
  "attract:actions": {
   "width": 786,
   "height": 599,
   "desks": [
    {
     "id": "desk-0",
     "slug": "posts",
     "label": "Posts",
     "step": "1.21",
     "to": "/attract/actions/posts",
     "kind": "social",
     "soon": false,
     "hit": {
      "left": 264,
      "top": 142,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 376,
      "y": 165
     }
    },
    {
     "id": "desk-1",
     "slug": "long-form",
     "label": "Articles and blog",
     "step": "1.2",
     "to": "/attract/actions/long-form",
     "kind": "type",
     "soon": false,
     "hit": {
      "left": 371,
      "top": 204,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 484,
      "y": 227
     }
    },
    {
     "id": "desk-2",
     "slug": "website",
     "label": "Website",
     "step": "0.20",
     "to": "/attract/actions/website",
     "kind": "web",
     "soon": false,
     "hit": {
      "left": 479,
      "top": 266,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 591,
      "y": 289
     }
    },
    {
     "id": "desk-3",
     "slug": "newsletter",
     "label": "Newsletter",
     "step": "1.9",
     "to": "/attract/actions/newsletter",
     "kind": "type",
     "soon": false,
     "hit": {
      "left": 167,
      "top": 198,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 279,
      "y": 221
     }
    },
    {
     "id": "desk-4",
     "slug": "ads",
     "label": "Ads",
     "step": "1.28",
     "to": "/attract/actions/ads",
     "kind": "billboard",
     "soon": false,
     "hit": {
      "left": 274,
      "top": 260,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 387,
      "y": 283
     }
    },
    {
     "id": "desk-5",
     "slug": "listings",
     "label": "Listings to claim",
     "step": "1.43",
     "to": "/attract/actions/listings",
     "kind": "stars",
     "soon": false,
     "hit": {
      "left": 382,
      "top": 322,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 494,
      "y": 345
     }
    },
    {
     "id": "desk-6",
     "slug": "pipeline",
     "label": "Pipeline",
     "step": "1.6",
     "to": "/attract/actions/pipeline",
     "kind": "chart",
     "soon": false,
     "hit": {
      "left": 70,
      "top": 254,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 182,
      "y": 277
     }
    },
    {
     "id": "desk-7",
     "slug": "refresh",
     "label": "Refresh old articles",
     "step": "1.36",
     "to": "/attract/actions/refresh",
     "kind": "type",
     "soon": false,
     "hit": {
      "left": 177,
      "top": 316,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 290,
      "y": 339
     }
    }
   ],
   "back": {
    "x": 206,
    "y": 242
   }
  },
  "attract:performance": {
   "width": 592,
   "height": 487,
   "desks": [
    {
     "id": "desk-0",
     "slug": "results",
     "label": "Results",
     "step": "1.19",
     "to": "/attract/performance/results",
     "kind": "chart",
     "soon": false,
     "hit": {
      "left": 70,
      "top": 142,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 182,
      "y": 165
     }
    },
    {
     "id": "desk-1",
     "slug": "post-results",
     "label": "Per-post results",
     "step": "1.22",
     "to": "/attract/performance/post-results",
     "kind": "social",
     "soon": false,
     "hit": {
      "left": 177,
      "top": 204,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 290,
      "y": 227
     }
    },
    {
     "id": "desk-2",
     "slug": "health",
     "label": "Health",
     "step": "0.24",
     "to": "/attract/performance/health",
     "kind": "ecg",
     "soon": false,
     "hit": {
      "left": 285,
      "top": 266,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 397,
      "y": 289
     }
    }
   ],
   "back": {
    "x": 109,
    "y": 186
   }
  },
  "find:accounts": {
   "width": 786,
   "height": 599,
   "desks": [
    {
     "id": "desk-0",
     "slug": "mailboxes",
     "label": "Mailboxes",
     "step": "4.3",
     "to": "/settings/sending",
     "kind": "mail",
     "soon": false,
     "hit": {
      "left": 264,
      "top": 142,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 376,
      "y": 165
     }
    },
    {
     "id": "desk-1",
     "slug": "data-sources",
     "label": "Data sources",
     "step": "2.1",
     "to": "/settings/data/sources",
     "kind": "cabinet",
     "soon": false,
     "hit": {
      "left": 371,
      "top": 204,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 484,
      "y": 227
     }
    },
    {
     "id": "desk-2",
     "slug": "crm-link",
     "label": "CRM link",
     "step": "0.28",
     "to": "/settings/data/crm-link",
     "kind": "key",
     "soon": false,
     "hit": {
      "left": 479,
      "top": 266,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 591,
      "y": 289
     }
    },
    {
     "id": "desk-3",
     "slug": "send-more",
     "label": "Send more each day",
     "step": "4.3",
     "to": "/settings/sending/more",
     "kind": "key",
     "soon": false,
     "hit": {
      "left": 167,
      "top": 198,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 279,
      "y": 221
     }
    },
    {
     "id": "desk-4",
     "slug": "phone",
     "label": "Phone",
     "step": "4.13",
     "to": "/settings/modules/phone",
     "kind": "phone",
     "soon": false,
     "hit": {
      "left": 274,
      "top": 260,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 387,
      "y": 283
     }
    },
    {
     "id": "desk-5",
     "slug": "letters",
     "label": "Letters",
     "step": "4.4",
     "to": "/settings/modules/letters",
     "kind": "mail",
     "soon": false,
     "hit": {
      "left": 382,
      "top": 322,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 494,
      "y": 345
     }
    },
    {
     "id": "desk-6",
     "slug": "whatsapp",
     "label": "WhatsApp",
     "step": "4.9",
     "to": "/settings/modules/whatsapp-outreach",
     "kind": "chat",
     "soon": false,
     "hit": {
      "left": 70,
      "top": 254,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 182,
      "y": 277
     }
    },
    {
     "id": "desk-7",
     "slug": "linkedin",
     "label": "LinkedIn",
     "step": "3.5",
     "to": "/settings/modules/linkedin",
     "kind": "social",
     "soon": false,
     "hit": {
      "left": 177,
      "top": 316,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 290,
      "y": 339
     }
    }
   ],
   "back": {
    "x": 206,
    "y": 242
   }
  },
  "find:rules": {
   "width": 581,
   "height": 481,
   "desks": [
    {
     "id": "desk-0",
     "slug": "sending",
     "label": "Sending rules",
     "step": "4.3",
     "to": "/settings/sending/times",
     "kind": "mail",
     "soon": false,
     "hit": {
      "left": 167,
      "top": 142,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 279,
      "y": 165
     }
    },
    {
     "id": "desk-1",
     "slug": "style",
     "label": "Sending style",
     "step": "4.2",
     "to": "/settings/campaign-defaults",
     "kind": "mail",
     "soon": false,
     "hit": {
      "left": 274,
      "top": 204,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 387,
      "y": 227
     }
    },
    {
     "id": "desk-2",
     "slug": "campaigns",
     "label": "Campaigns",
     "step": "2.30",
     "to": "/prospects/campaigns",
     "kind": "mail",
     "soon": false,
     "hit": {
      "left": 70,
      "top": 198,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 182,
      "y": 221
     }
    },
    {
     "id": "desk-3",
     "slug": "approvals",
     "label": "Approvals and spend",
     "step": "E13",
     "to": "/settings/approvals/outreach",
     "kind": "stamp",
     "soon": false,
     "hit": {
      "left": 177,
      "top": 260,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 290,
      "y": 283
     }
    }
   ],
   "back": {
    "x": 157,
    "y": 214
   }
  },
  "find:research": {
   "width": 581,
   "height": 481,
   "desks": [
    {
     "id": "desk-0",
     "slug": "prospects",
     "label": "Find prospects",
     "step": "2.1",
     "to": "/prospects/search",
     "kind": "search",
     "soon": false,
     "hit": {
      "left": 167,
      "top": 142,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 279,
      "y": 165
     }
    },
    {
     "id": "desk-1",
     "slug": "long-list",
     "label": "Long list",
     "step": "2.1",
     "to": "/prospects/lined-up",
     "kind": "search",
     "soon": false,
     "hit": {
      "left": 274,
      "top": 204,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 387,
      "y": 227
     }
    },
    {
     "id": "desk-2",
     "slug": "add-target",
     "label": "Add a target",
     "step": "2.21",
     "to": "/prospects/lined-up/add",
     "kind": "search",
     "soon": false,
     "hit": {
      "left": 70,
      "top": 198,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 182,
      "y": 221
     }
    },
    {
     "id": "desk-3",
     "slug": "signals",
     "label": "Signals and news",
     "step": "2.4",
     "to": "/prospects/lined-up/news",
     "kind": "type",
     "soon": false,
     "hit": {
      "left": 177,
      "top": 260,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 290,
      "y": 283
     }
    }
   ],
   "back": {
    "x": 157,
    "y": 214
   }
  },
  "find:actions": {
   "width": 689,
   "height": 543,
   "desks": [
    {
     "id": "desk-0",
     "slug": "overview",
     "label": "Overview",
     "step": "4.10",
     "to": "/home",
     "kind": "mail",
     "soon": false,
     "hit": {
      "left": 167,
      "top": 142,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 279,
      "y": 165
     }
    },
    {
     "id": "desk-1",
     "slug": "sending",
     "label": "Automatic sending",
     "step": "4.3",
     "to": "/prospects/drafts/scheduled",
     "kind": "mail",
     "soon": false,
     "hit": {
      "left": 274,
      "top": 204,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 387,
      "y": 227
     }
    },
    {
     "id": "desk-2",
     "slug": "drafts",
     "label": "Drafts to approve",
     "step": "4.10",
     "to": "/prospects/drafts",
     "kind": "mail",
     "soon": false,
     "hit": {
      "left": 382,
      "top": 266,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 494,
      "y": 289
     }
    },
    {
     "id": "desk-3",
     "slug": "by-hand",
     "label": "Drafts to send yourself",
     "step": "4.23",
     "to": "/prospects/drafts/yourself",
     "kind": "mail",
     "soon": false,
     "hit": {
      "left": 70,
      "top": 198,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 182,
      "y": 221
     }
    },
    {
     "id": "desk-4",
     "slug": "calls",
     "label": "Calls to make",
     "step": "4.13",
     "to": "/settings/modules/calls",
     "kind": "phone",
     "soon": false,
     "hit": {
      "left": 177,
      "top": 260,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 290,
      "y": 283
     }
    },
    {
     "id": "desk-5",
     "slug": "week",
     "label": "Next 7 days",
     "step": "2.21",
     "to": "/prospects/drafts/week",
     "kind": "target",
     "soon": false,
     "hit": {
      "left": 285,
      "top": 322,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 397,
      "y": 345
     }
    }
   ],
   "back": {
    "x": 157,
    "y": 214
   }
  },
  "find:performance": {
   "width": 581,
   "height": 481,
   "desks": [
    {
     "id": "desk-0",
     "slug": "results",
     "label": "Results",
     "step": "10.8",
     "to": "/results/outreach",
     "kind": "chart",
     "soon": false,
     "hit": {
      "left": 167,
      "top": 142,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 279,
      "y": 165
     }
    },
    {
     "id": "desk-1",
     "slug": "advice",
     "label": "Advice",
     "step": "10.9",
     "to": "/results/outreach/advice",
     "kind": "chart",
     "soon": false,
     "hit": {
      "left": 274,
      "top": 204,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 387,
      "y": 227
     }
    },
    {
     "id": "desk-2",
     "slug": "time",
     "label": "Time saved",
     "step": "10.8",
     "to": "/results/time",
     "kind": "chart",
     "soon": false,
     "hit": {
      "left": 70,
      "top": 198,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 182,
      "y": 221
     }
    },
    {
     "id": "desk-3",
     "slug": "health",
     "label": "Health",
     "step": "2.39",
     "to": "/settings/sending/health",
     "kind": "ecg",
     "soon": false,
     "hit": {
      "left": 177,
      "top": 260,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 290,
      "y": 283
     }
    }
   ],
   "back": {
    "x": 157,
    "y": 214
   }
  },
  "network:accounts": {
   "width": 581,
   "height": 481,
   "desks": [
    {
     "id": "desk-0",
     "slug": "review-sites",
     "label": "Review sites",
     "step": "1.45",
     "to": "/network/accounts/review-sites",
     "kind": "stars",
     "soon": false,
     "hit": {
      "left": 167,
      "top": 142,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 279,
      "y": 165
     }
    },
    {
     "id": "desk-1",
     "slug": "labels",
     "label": "Mailbox labels",
     "step": "2.8",
     "to": "/network/accounts/labels",
     "kind": "mail",
     "soon": true,
     "hit": {
      "left": 274,
      "top": 204,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 387,
      "y": 227
     }
    },
    {
     "id": "desk-2",
     "slug": "calendar",
     "label": "Calendar",
     "step": "0.8",
     "to": "/network/accounts/calendar",
     "kind": "calendar",
     "soon": false,
     "hit": {
      "left": 70,
      "top": 198,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 182,
      "y": 221
     }
    },
    {
     "id": "desk-3",
     "slug": "tags",
     "label": "Introducer and referrer tags",
     "step": "3.10",
     "to": "/network/accounts/tags",
     "kind": "cards",
     "soon": false,
     "hit": {
      "left": 177,
      "top": 260,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 290,
      "y": 283
     }
    }
   ],
   "back": {
    "x": 157,
    "y": 214
   }
  },
  "network:rules": {
   "width": 581,
   "height": 481,
   "desks": [
    {
     "id": "desk-0",
     "slug": "reviews",
     "label": "Reviews",
     "step": "10.19",
     "to": "/network/rules/reviews",
     "kind": "stars",
     "soon": false,
     "hit": {
      "left": 167,
      "top": 142,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 279,
      "y": 165
     }
    },
    {
     "id": "desk-1",
     "slug": "referrals",
     "label": "Referrals",
     "step": "10.3",
     "to": "/network/rules/referrals",
     "kind": "board",
     "soon": false,
     "hit": {
      "left": 274,
      "top": 204,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 387,
      "y": 227
     }
    },
    {
     "id": "desk-2",
     "slug": "events-reach",
     "label": "Events reach",
     "step": "2.22",
     "to": "/network/rules/events-reach",
     "kind": "calendar",
     "soon": false,
     "hit": {
      "left": 70,
      "top": 198,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 182,
      "y": 221
     }
    },
    {
     "id": "desk-3",
     "slug": "approvals",
     "label": "Approvals",
     "step": "E13",
     "to": "/network/rules/approvals",
     "kind": "stamp",
     "soon": false,
     "hit": {
      "left": 177,
      "top": 260,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 290,
      "y": 283
     }
    }
   ],
   "back": {
    "x": 157,
    "y": 214
   }
  },
  "network:research": {
   "width": 592,
   "height": 487,
   "desks": [
    {
     "id": "desk-0",
     "slug": "events",
     "label": "Events found",
     "step": "2.22",
     "to": "/network/research/events",
     "kind": "calendar",
     "soon": false,
     "hit": {
      "left": 70,
      "top": 142,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 182,
      "y": 165
     }
    },
    {
     "id": "desk-1",
     "slug": "introducers",
     "label": "Introducers and partners",
     "step": "2.7",
     "to": "/network/research/introducers",
     "kind": "cards",
     "soon": false,
     "hit": {
      "left": 177,
      "top": 204,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 290,
      "y": 227
     }
    },
    {
     "id": "desk-2",
     "slug": "communities",
     "label": "Communities and associations",
     "step": null,
     "to": "/network/research/communities",
     "kind": "cards",
     "soon": true,
     "hit": {
      "left": 285,
      "top": 266,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 397,
      "y": 289
     }
    }
   ],
   "back": {
    "x": 109,
    "y": 186
   }
  },
  "network:actions": {
   "width": 689,
   "height": 543,
   "desks": [
    {
     "id": "desk-0",
     "slug": "waiting",
     "label": "Waiting for you",
     "step": "2.23",
     "to": "/network/actions/waiting",
     "kind": "stamp",
     "soon": false,
     "hit": {
      "left": 167,
      "top": 142,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 279,
      "y": 165
     }
    },
    {
     "id": "desk-1",
     "slug": "events",
     "label": "Your events",
     "step": "2.24",
     "to": "/network/actions/events",
     "kind": "calendar",
     "soon": false,
     "hit": {
      "left": 274,
      "top": 204,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 387,
      "y": 227
     }
    },
    {
     "id": "desk-2",
     "slug": "reviews",
     "label": "Reviews",
     "step": "1.46",
     "to": "/network/actions/reviews",
     "kind": "stars",
     "soon": false,
     "hit": {
      "left": 382,
      "top": 266,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 494,
      "y": 289
     }
    },
    {
     "id": "desk-3",
     "slug": "referral-asks",
     "label": "Referral asks",
     "step": "10.3",
     "to": "/network/actions/referral-asks",
     "kind": "board",
     "soon": false,
     "hit": {
      "left": 70,
      "top": 198,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 182,
      "y": 221
     }
    },
    {
     "id": "desk-4",
     "slug": "introductions",
     "label": "Introductions received",
     "step": "2.8",
     "to": "/network/actions/introductions",
     "kind": "chart",
     "soon": true,
     "hit": {
      "left": 177,
      "top": 260,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 290,
      "y": 283
     }
    }
   ],
   "back": {
    "x": 157,
    "y": 214
   }
  },
  "network:performance": {
   "width": 581,
   "height": 481,
   "desks": [
    {
     "id": "desk-0",
     "slug": "introductions",
     "label": "Introductions",
     "step": "2.7",
     "to": "/network/performance/introductions",
     "kind": "chart",
     "soon": false,
     "hit": {
      "left": 167,
      "top": 142,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 279,
      "y": 165
     }
    },
    {
     "id": "desk-1",
     "slug": "events",
     "label": "Events",
     "step": "2.29",
     "to": "/network/performance/events",
     "kind": "calendar",
     "soon": false,
     "hit": {
      "left": 274,
      "top": 204,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 387,
      "y": 227
     }
    },
    {
     "id": "desk-2",
     "slug": "reviews",
     "label": "Reviews",
     "step": "10.19",
     "to": "/network/performance/reviews",
     "kind": "stars",
     "soon": false,
     "hit": {
      "left": 70,
      "top": 198,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 182,
      "y": 221
     }
    },
    {
     "id": "desk-3",
     "slug": "health",
     "label": "Health",
     "step": "2.7",
     "to": "/network/performance/health",
     "kind": "ecg",
     "soon": false,
     "hit": {
      "left": 177,
      "top": 260,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 290,
      "y": 283
     }
    }
   ],
   "back": {
    "x": 157,
    "y": 214
   }
  },
  "connect:accounts": {
   "width": 786,
   "height": 599,
   "desks": [
    {
     "id": "desk-0",
     "slug": "overview",
     "label": "Overview",
     "step": "0.49",
     "to": "/settings/connections/sales",
     "kind": "key",
     "soon": false,
     "hit": {
      "left": 264,
      "top": 142,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 376,
      "y": 165
     }
    },
    {
     "id": "desk-1",
     "slug": "calendar",
     "label": "Calendar",
     "step": "7.4",
     "to": "/settings/meetings",
     "kind": "calendar",
     "soon": false,
     "hit": {
      "left": 371,
      "top": 204,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 484,
      "y": 227
     }
    },
    {
     "id": "desk-2",
     "slug": "booking-links",
     "label": "Booking links",
     "step": "7.9",
     "to": "/settings/meetings/links",
     "kind": "web",
     "soon": false,
     "hit": {
      "left": 479,
      "top": 266,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 591,
      "y": 289
     }
    },
    {
     "id": "desk-3",
     "slug": "video",
     "label": "Video call tool",
     "step": "7.4",
     "to": "/settings/meetings/video",
     "kind": "video",
     "soon": false,
     "hit": {
      "left": 167,
      "top": 198,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 279,
      "y": 221
     }
    },
    {
     "id": "desk-4",
     "slug": "whatsapp",
     "label": "WhatsApp number",
     "step": "0.30",
     "to": "/settings/modules/whatsapp",
     "kind": "chat",
     "soon": false,
     "hit": {
      "left": 274,
      "top": 260,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 387,
      "y": 283
     }
    },
    {
     "id": "desk-5",
     "slug": "phone-line",
     "label": "Phone line",
     "step": "5.13",
     "to": "/settings/modules/phone-line",
     "kind": "phone",
     "soon": false,
     "hit": {
      "left": 382,
      "top": 322,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 494,
      "y": 345
     }
    },
    {
     "id": "desk-6",
     "slug": "payments",
     "label": "Payments",
     "step": "9.20",
     "to": "/settings/connections/payments",
     "kind": "till",
     "soon": false,
     "hit": {
      "left": 70,
      "top": 254,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 182,
      "y": 277
     }
    },
    {
     "id": "desk-7",
     "slug": "documents",
     "label": "Documents",
     "step": "9.6",
     "to": "/settings/connections/documents",
     "kind": "doc",
     "soon": true,
     "hit": {
      "left": 177,
      "top": 316,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 290,
      "y": 339
     }
    },
    {
     "id": "desk-8",
     "slug": "notetaker",
     "label": "Meeting notetaker",
     "step": "8.8",
     "to": "/settings/meetings/notetaker",
     "kind": "calendar",
     "soon": false,
     "hit": {
      "left": 285,
      "top": 378,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 397,
      "y": 401
     }
    }
   ],
   "back": {
    "x": 206,
    "y": 242
   }
  },
  "connect:rules": {
   "width": 786,
   "height": 599,
   "desks": [
    {
     "id": "desk-0",
     "slug": "paths",
     "label": "Paths per campaign",
     "step": "9.13",
     "to": "/conversations/routes",
     "kind": "doc",
     "soon": false,
     "hit": {
      "left": 264,
      "top": 142,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 376,
      "y": 165
     }
    },
    {
     "id": "desk-1",
     "slug": "booking-hours",
     "label": "Booking hours",
     "step": "7.4",
     "to": "/settings/meetings/hours",
     "kind": "book",
     "soon": false,
     "hit": {
      "left": 371,
      "top": 204,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 484,
      "y": 227
     }
    },
    {
     "id": "desk-2",
     "slug": "documents",
     "label": "Documents",
     "step": "9.1",
     "to": "/settings/campaign-defaults/documents",
     "kind": "doc",
     "soon": false,
     "hit": {
      "left": 479,
      "top": 266,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 591,
      "y": 289
     }
    },
    {
     "id": "desk-3",
     "slug": "speed-to-lead",
     "label": "Speed to lead",
     "step": "1.61",
     "to": "/settings/campaign-defaults/speed",
     "kind": "dial",
     "soon": false,
     "hit": {
      "left": 167,
      "top": 198,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 279,
      "y": 221
     }
    },
    {
     "id": "desk-4",
     "slug": "meeting-types",
     "label": "Meeting types and reminders",
     "step": "7.8",
     "to": "/settings/meetings/types",
     "kind": "calendar",
     "soon": false,
     "hit": {
      "left": 274,
      "top": 260,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 387,
      "y": 283
     }
    },
    {
     "id": "desk-5",
     "slug": "save-offer",
     "label": "Save offer",
     "step": "9.11",
     "to": "/settings/campaign-defaults/save-offer",
     "kind": "target",
     "soon": false,
     "hit": {
      "left": 382,
      "top": 322,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 494,
      "y": 345
     }
    },
    {
     "id": "desk-6",
     "slug": "whatsapp",
     "label": "WhatsApp templates",
     "step": "0.31",
     "to": "/settings/modules/whatsapp-templates",
     "kind": "chat",
     "soon": false,
     "hit": {
      "left": 70,
      "top": 254,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 182,
      "y": 277
     }
    },
    {
     "id": "desk-7",
     "slug": "approvals",
     "label": "Approvals",
     "step": "E13",
     "to": "/settings/approvals/conversations",
     "kind": "stamp",
     "soon": false,
     "hit": {
      "left": 177,
      "top": 316,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 290,
      "y": 339
     }
    }
   ],
   "back": {
    "x": 206,
    "y": 242
   }
  },
  "connect:research": {
   "width": 484,
   "height": 425,
   "desks": [
    {
     "id": "desk-0",
     "slug": "briefs",
     "label": "Meeting briefs",
     "step": "8.1",
     "to": "/conversations/meetings/briefs",
     "kind": "calendar",
     "soon": false,
     "hit": {
      "left": 70,
      "top": 142,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 182,
      "y": 165
     }
    },
    {
     "id": "desk-1",
     "slug": "history",
     "label": "Relationship history",
     "step": "8.1",
     "to": "/conversations/meetings/history",
     "kind": "cabinet",
     "soon": false,
     "hit": {
      "left": 177,
      "top": 204,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 290,
      "y": 227
     }
    }
   ],
   "back": {
    "x": 109,
    "y": 186
   }
  },
  "connect:actions": {
   "width": 581,
   "height": 481,
   "desks": [
    {
     "id": "desk-0",
     "slug": "conversations",
     "label": "Conversations",
     "step": "6.16",
     "to": "/conversations/inbox",
     "kind": "chat",
     "soon": false,
     "hit": {
      "left": 167,
      "top": 142,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 279,
      "y": 165
     }
    },
    {
     "id": "desk-1",
     "slug": "next-steps",
     "label": "Next steps",
     "step": "4.10",
     "to": "/conversations/next-steps",
     "kind": "stamp",
     "soon": false,
     "hit": {
      "left": 274,
      "top": 204,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 387,
      "y": 227
     }
    },
    {
     "id": "desk-2",
     "slug": "meetings",
     "label": "Meetings",
     "step": "7.W",
     "to": "/conversations/meetings",
     "kind": "calendar",
     "soon": false,
     "hit": {
      "left": 70,
      "top": 198,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 182,
      "y": 221
     }
    },
    {
     "id": "desk-3",
     "slug": "deals",
     "label": "Deals board",
     "step": "9.W",
     "to": "/conversations/deals",
     "kind": "board",
     "soon": false,
     "hit": {
      "left": 177,
      "top": 260,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 290,
      "y": 283
     }
    }
   ],
   "back": {
    "x": 157,
    "y": 214
   }
  },
  "connect:performance": {
   "width": 689,
   "height": 543,
   "desks": [
    {
     "id": "desk-0",
     "slug": "sales",
     "label": "Sales performance",
     "step": "10.8",
     "to": "/results/overview",
     "kind": "chart",
     "soon": false,
     "hit": {
      "left": 167,
      "top": 142,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 279,
      "y": 165
     }
    },
    {
     "id": "desk-1",
     "slug": "pipeline",
     "label": "Pipeline summary",
     "step": "6.W",
     "to": "/results/sales",
     "kind": "chart",
     "soon": false,
     "hit": {
      "left": 274,
      "top": 204,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 387,
      "y": 227
     }
    },
    {
     "id": "desk-2",
     "slug": "speed-to-lead",
     "label": "Speed to lead",
     "step": "1.61",
     "to": "/results/sales/speed",
     "kind": "dial",
     "soon": false,
     "hit": {
      "left": 382,
      "top": 266,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 494,
      "y": 289
     }
    },
    {
     "id": "desk-3",
     "slug": "time",
     "label": "Time",
     "step": "10.8",
     "to": "/results/time/conversations",
     "kind": "chart",
     "soon": false,
     "hit": {
      "left": 70,
      "top": 198,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 182,
      "y": 221
     }
    },
    {
     "id": "desk-4",
     "slug": "payments",
     "label": "Payments",
     "step": "9.21",
     "to": "/results/sales/payments",
     "kind": "till",
     "soon": false,
     "hit": {
      "left": 177,
      "top": 260,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 290,
      "y": 283
     }
    },
    {
     "id": "desk-5",
     "slug": "health",
     "label": "Health",
     "step": "E15",
     "to": "/settings/account/checks",
     "kind": "ecg",
     "soon": false,
     "hit": {
      "left": 285,
      "top": 322,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 397,
      "y": 345
     }
    }
   ],
   "back": {
    "x": 157,
    "y": 214
   }
  },
  "reconnect:accounts": {
   "width": 484,
   "height": 425,
   "desks": [
    {
     "id": "desk-0",
     "slug": "history",
     "label": "Your history",
     "step": "0.40",
     "to": "/reconnect/accounts/history",
     "kind": "cabinet",
     "soon": false,
     "hit": {
      "left": 70,
      "top": 142,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 182,
      "y": 165
     }
    },
    {
     "id": "desk-1",
     "slug": "whatsapp",
     "label": "WhatsApp",
     "step": "0.30",
     "to": "/reconnect/accounts/whatsapp",
     "kind": "chat",
     "soon": false,
     "hit": {
      "left": 177,
      "top": 204,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 290,
      "y": 227
     }
    }
   ],
   "back": {
    "x": 109,
    "y": 186
   }
  },
  "reconnect:rules": {
   "width": 689,
   "height": 543,
   "desks": [
    {
     "id": "desk-0",
     "slug": "keep-warm",
     "label": "Keep-warm rules",
     "step": "10.11",
     "to": "/reconnect/rules/keep-warm",
     "kind": "clock",
     "soon": false,
     "hit": {
      "left": 167,
      "top": 142,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 279,
      "y": 165
     }
    },
    {
     "id": "desk-1",
     "slug": "offers",
     "label": "Offers per loss reason",
     "step": "10.10",
     "to": "/reconnect/rules/offers",
     "kind": "target",
     "soon": false,
     "hit": {
      "left": 274,
      "top": 204,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 387,
      "y": 227
     }
    },
    {
     "id": "desk-2",
     "slug": "whatsapp-updates",
     "label": "How WhatsApp updates go out",
     "step": "10.13",
     "to": "/reconnect/rules/whatsapp-updates",
     "kind": "chat",
     "soon": false,
     "hit": {
      "left": 382,
      "top": 266,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 494,
      "y": 289
     }
    },
    {
     "id": "desk-3",
     "slug": "signals",
     "label": "Job moves and things worth sharing",
     "step": "10.16",
     "to": "/reconnect/rules/signals",
     "kind": "search",
     "soon": true,
     "hit": {
      "left": 70,
      "top": 198,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 182,
      "y": 221
     }
    },
    {
     "id": "desk-4",
     "slug": "approvals",
     "label": "Approvals",
     "step": "E13",
     "to": "/reconnect/rules/approvals",
     "kind": "stamp",
     "soon": false,
     "hit": {
      "left": 177,
      "top": 260,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 290,
      "y": 283
     }
    }
   ],
   "back": {
    "x": 157,
    "y": 214
   }
  },
  "reconnect:research": {
   "width": 581,
   "height": 481,
   "desks": [
    {
     "id": "desk-0",
     "slug": "not-ready",
     "label": "Not ready yet",
     "step": "10.R",
     "to": "/reconnect/research/not-ready",
     "kind": "search",
     "soon": false,
     "hit": {
      "left": 167,
      "top": 142,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 279,
      "y": 165
     }
    },
    {
     "id": "desk-1",
     "slug": "lost-deals",
     "label": "Deals lost",
     "step": "10.10",
     "to": "/reconnect/research/lost-deals",
     "kind": "search",
     "soon": false,
     "hit": {
      "left": 274,
      "top": 204,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 387,
      "y": 227
     }
    },
    {
     "id": "desk-2",
     "slug": "spoken-before",
     "label": "Spoken to before",
     "step": "10.15",
     "to": "/reconnect/research/spoken-before",
     "kind": "search",
     "soon": false,
     "hit": {
      "left": 70,
      "top": 198,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 182,
      "y": 221
     }
    },
    {
     "id": "desk-3",
     "slug": "moved",
     "label": "They've moved",
     "step": "10.16",
     "to": "/reconnect/research/moved",
     "kind": "search",
     "soon": false,
     "hit": {
      "left": 177,
      "top": 260,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 290,
      "y": 283
     }
    }
   ],
   "back": {
    "x": 157,
    "y": 214
   }
  },
  "reconnect:actions": {
   "width": 689,
   "height": 543,
   "desks": [
    {
     "id": "desk-0",
     "slug": "waiting",
     "label": "Waiting for you",
     "step": "10.11",
     "to": "/reconnect/actions/waiting",
     "kind": "stamp",
     "soon": false,
     "hit": {
      "left": 167,
      "top": 142,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 279,
      "y": 165
     }
    },
    {
     "id": "desk-1",
     "slug": "follow-ups",
     "label": "Plan follow-ups",
     "step": "10.14",
     "to": "/reconnect/actions/follow-ups",
     "kind": "clock",
     "soon": false,
     "hit": {
      "left": 274,
      "top": 204,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 387,
      "y": 227
     }
    },
    {
     "id": "desk-2",
     "slug": "whatsapp",
     "label": "WhatsApp updates",
     "step": "10.13",
     "to": "/reconnect/actions/whatsapp",
     "kind": "chat",
     "soon": false,
     "hit": {
      "left": 382,
      "top": 266,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 494,
      "y": 289
     }
    },
    {
     "id": "desk-3",
     "slug": "bulk-emails",
     "label": "Bulk emails",
     "step": "4.11",
     "to": "/reconnect/actions/bulk-emails",
     "kind": "mail",
     "soon": false,
     "hit": {
      "left": 70,
      "top": 198,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 182,
      "y": 221
     }
    },
    {
     "id": "desk-4",
     "slug": "offers",
     "label": "Offers made",
     "step": "10.10",
     "to": "/reconnect/actions/offers",
     "kind": "target",
     "soon": true,
     "hit": {
      "left": 177,
      "top": 260,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 290,
      "y": 283
     }
    }
   ],
   "back": {
    "x": 157,
    "y": 214
   }
  },
  "reconnect:performance": {
   "width": 484,
   "height": 425,
   "desks": [
    {
     "id": "desk-0",
     "slug": "results",
     "label": "Results",
     "step": "10.8",
     "to": "/reconnect/performance/results",
     "kind": "chart",
     "soon": false,
     "hit": {
      "left": 70,
      "top": 142,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 182,
      "y": 165
     }
    },
    {
     "id": "desk-1",
     "slug": "health",
     "label": "Health",
     "step": "10.R",
     "to": "/reconnect/performance/health",
     "kind": "ecg",
     "soon": false,
     "hit": {
      "left": 177,
      "top": 204,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 290,
      "y": 227
     }
    }
   ],
   "back": {
    "x": 109,
    "y": 186
   }
  },
  "crm:records": {
   "width": 949,
   "height": 693,
   "desks": [
    {
     "id": "desk-0",
     "slug": "companies",
     "label": "Companies",
     "step": "2.W",
     "to": "/contacts/companies",
     "kind": "cabinet",
     "soon": false,
     "hit": {
      "left": 70,
      "top": 162,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 182,
      "y": 185
     }
    },
    {
     "id": "desk-1",
     "slug": "people",
     "label": "People",
     "step": "3.10",
     "to": "/contacts/people",
     "kind": "cards",
     "soon": false,
     "hit": {
      "left": 177,
      "top": 224,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 290,
      "y": 247
     }
    },
    {
     "id": "desk-2",
     "slug": "duplicates",
     "label": "Duplicates",
     "step": "3.15",
     "to": "/settings/data/duplicates",
     "kind": "merge",
     "soon": false,
     "hit": {
      "left": 285,
      "top": 286,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 397,
      "y": 309
     }
    },
    {
     "id": "desk-3",
     "slug": "contacts",
     "label": "Your contacts",
     "step": "0.28",
     "to": "/settings/data",
     "kind": "cards",
     "soon": false,
     "hit": {
      "left": 392,
      "top": 348,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 505,
      "y": 371
     }
    },
    {
     "id": "desk-4",
     "slug": "deals",
     "label": "Deals",
     "step": "9.W",
     "to": "/conversations/deals",
     "kind": "board",
     "soon": false,
     "hit": {
      "left": 499,
      "top": 410,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 612,
      "y": 433
     }
    },
    {
     "id": "desk-5",
     "slug": "settings",
     "label": "Settings",
     "step": "3.10",
     "to": "/settings/data/crm",
     "kind": "key",
     "soon": false,
     "hit": {
      "left": 607,
      "top": 472,
      "width": 196,
      "height": 159,
      "clip": "94px 0px, 196px 59px, 102px 159px, 0px 100px"
     },
     "plate": {
      "x": 719,
      "y": 495
     }
    }
   ],
   "back": {
    "x": 126,
    "y": 196
   }
  }
 },
 "tour": [
  {
   "building": null,
   "text": "Welcome to your engine. Each building is one part of Ogma Hub, and the roads show how a customer moves from one to the next."
  },
  {
   "building": "hq",
   "text": "Settings, along the top. Your playbook, offer, brand and team: everything every other building works from."
  },
  {
   "building": "attract",
   "text": "Ogma Attract. Posts, articles, newsletters and ads are drafted, approved by you and published, and every enquiry they bring in is caught."
  },
  {
   "building": "find",
   "text": "Ogma Find. Firms are found, checked against do-not-contact lists, and written to from your own mailbox."
  },
  {
   "building": "network",
   "text": "Ogma Network. Introducers, referrals, reviews and events: relationship first, offer later."
  },
  {
   "building": "connect",
   "text": "Ogma Connect. All three roads meet here: every reply is read, meetings are booked, and every offer waits for your yes."
  },
  {
   "building": "reconnect",
   "text": "Ogma ReConnect. Not now isn’t never: people are kept warm and brought back round to Connect."
  },
  {
   "building": null,
   "text": "Ogma Complete and Ogma Serve, greyed out on the right, are coming soon: delivering the work, then looking after the customer."
  },
  {
   "building": "crm",
   "text": "The CRM, along the bottom. Every person, firm and deal that any building touches is filed here, in one place."
  },
  {
   "building": null,
   "text": "Inside each building are five offices: Accounts, Rules, Research, Actions and Performance. Walk in, and every desk has its own worker and its own page."
  }
 ]
};
